var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"content-layout"},[_c('TabView',{attrs:{"titles":_vm.titles}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('img',{staticClass:"img",attrs:{"src":require("../assets/productsDetail-top.jpeg")}}),_c('div',{staticClass:"dec-layout"},[_c('p',{staticClass:"title"},[_vm._v("Best Training Plan")]),_c('p',{staticClass:"content"},[_vm._v("产品")])])])
}]

export { render, staticRenderFns }